/**
 * Fetches loyalty transactions from GET /api/admin/users/:userId/loyalty/transactions.
 * No cache (staleTime=0, gcTime=0), refetch on mount.
 */
import { useNoCacheQuery } from './useNoCacheQuery';
import {
  fetchUserLoyaltyTransactions,
  type UserLoyaltyTransactionsResponse,
} from '../services/userManagementService';

export function useUserLoyaltyTx(
  userId: string | undefined,
  params: { page?: number; limit?: number } = {}
) {
  const { page = 1, limit = 20 } = params;
  return useNoCacheQuery<
    {
      data: UserLoyaltyTransactionsResponse['data'];
      pagination: UserLoyaltyTransactionsResponse['pagination'];
    },
    Error
  >({
    queryKey: ['user', userId, 'loyalty', 'transactions', page, limit],
    queryFn: async () => {
      if (!userId) throw new Error('userId required');
      const res = await fetchUserLoyaltyTransactions(userId, { page, limit });
      if (!res.success) throw new Error('Failed to load loyalty transactions');
      return { data: res.data, pagination: res.pagination };
    },
    enabled: !!userId,
  });
}
